import { Accordion, InfoCard } from 'component-library'
import { withPrefix } from 'gatsby'
import LinkComponent from '../LinkComponent/LinkComponent'
import LearningMaterials from '../../../content/learningMaterials'

import './DatasetLearningMaterials.scss'

const DatasetLearningMaterials = () => {
  return (
    <section
      className="DatasetLearningMaterials"
      data-testid="dataset-learning-materials"
    >
      <ul className="mt-12 mx-auto font-quicksand">
        {LearningMaterials.map((learningMaterial) => {
          return (
            <li key={learningMaterial.accordionTitle.replaceAll(' ', '-')}>
              <Accordion
                itemTitle={learningMaterial.accordionTitle}
                isExpandedDefault={true}
                itemContent={
                  <>
                    <ul className="LearningMaterialsGrid !list-none !ml-0 !pl-0">
                      {learningMaterial.materialLinks.map((materialLink) => {
                        return (
                          <li key={materialLink.link}>
                            <LinkComponent href={materialLink.link}>
                              <InfoCard
                                label={materialLink.label}
                                image={withPrefix(materialLink.image)}
                              />
                            </LinkComponent>
                          </li>
                        )
                      })}
                    </ul>
                    <hr className="mt-12 text-[#B4B4B4]" />
                  </>
                }
              />
            </li>
          )
        })}
      </ul>
    </section>
  )
}

export default DatasetLearningMaterials
